import { render, staticRenderFns } from "./AdminDropdownList.vue?vue&type=template&id=00ac9f0a"
import script from "./AdminDropdownList.vue?vue&type=script&lang=js"
export * from "./AdminDropdownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports